<template>
    <div class="vue-specialism-tabs" v-if="hasTabs">
        <ul class="tab-buttons">
            <li v-for="tab in tabs">
                <zoa-specialism-tab-button
                    :key="tab.id"
                    :item="tab"
                    @selected-tab="handleSelectedTab"
                    :selected-id="selectedId"
                ></zoa-specialism-tab-button>
            </li>
        </ul>

        <transition name="fade">
            <div class="active-tab" v-if="hasSelectedTab">
                <div v-html="selectedTab.description"></div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "SpecialismTabs",

    props: ['tabs'],

    data() {
        return {
            selectedId: null,
        }
    },

    computed: {
        hasTabs() {
            return !_.isEmpty(this.tabs);
        },

        selectedTab() {
            return _.find(this.tabs, (tab) => {
                return tab.id === this.selectedId;
            });
        },

        hasSelectedTab() {
            return !_.isNil(this.selectedTab);
        }
    },

    mounted() {
        this.setDefaultTab();
    },

    methods: {
        handleSelectedTab(payload) {
            this.selectedId = payload;
        },

        setDefaultTab() {
            if (!this.hasTabs) {
                return;
            }

            const firstTab = _.head(this.tabs);

            this.selectedId = firstTab.id;
        }
    }
}
</script>